function playPauseVideo() {
	const iframe = $('.singleCareer-video iframe')[0]
	const player = new Vimeo.Player(iframe);

	$('.singleCareer-video').on('click', function() {
		$(this).toggleClass('played')

		if ($(this).hasClass('played')) {
			player.play()
		} else {
			player.pause()
		}
	})
}

export default {
	init () {
		if ($('.singleCareer-video').length) {
			playPauseVideo()
		}
	}
}